/* @flow */

import React from 'react';
import ResourceVideo from 'shared/components/ResourceVideo';

type Props = {
  resource: BucketResource,
};

const Video = ({ resource }: Props) => (
  <div className="content">
    <ResourceVideo video={resource} />
  </div>
);

export default Video;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folder/components/items/Video.js